var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileAddLine = function SvgFileAddLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.8 3.2h-6v9.6h8.4V5.6H9.8zm-7.2-.605c0-.329.268-.595.6-.595h7.2l3 3v8.396a.6.6 0 0 1-.596.604H3.196a.6.6 0 0 1-.596-.595zM7.4 7.4V5.6h1.2v1.8h1.8v1.2H8.6v1.8H7.4V8.6H5.6V7.4z"
  })));
};
export default SvgFileAddLine;